import { i18n } from '@/plugins/i18n'
import { SUPPORTED_LOCALES, type Locale, isLocale } from '@/router/locales'

export function normalizeLocale(input: unknown): string {
  if (typeof input === 'string') return input
  if (typeof input === 'object' && input !== null && 'value' in input) {
    return String(input.value)
  }
  return String(input)
}

export function getFallbackLocale(): Locale {
  return normalizeLocale(i18n.global.fallbackLocale) as Locale
}

// Important: keep type and value exports separate.
export { SUPPORTED_LOCALES, isLocale }
export type { Locale }
